import React, { forwardRef } from "react";

interface ChartCanvasProps {
  isDragging: boolean;
  onMouseMove: (e: React.MouseEvent<HTMLCanvasElement>) => void;
  onMouseLeave: () => void;
  onMouseDown: (e: React.MouseEvent<HTMLCanvasElement>) => void;
  onMouseUp: () => void;
  onWheel: (e: React.WheelEvent<HTMLCanvasElement>) => void;
  onClick: (e: React.MouseEvent<HTMLCanvasElement>) => void;
}

export const ChartCanvas = forwardRef<HTMLCanvasElement, ChartCanvasProps>(
  ({ isDragging, ...handlers }, ref) => {
    return (
      <canvas
        ref={ref}
        style={{
          width: "100%",
          height: "100%",
          display: "block",
          cursor: isDragging ? "default" : "crosshair",
        }}
        {...handlers}
      />
    );
  },
);

ChartCanvas.displayName = "ChartCanvas";
